import { isValidElement, ReactNode } from 'react';

import { Typography, TypographyProps } from '@scaleaq/scaleui';

type DataRowElement = string | ReactNode;

type TypographyWrapperProps = TypographyProps & {
  value: DataRowElement;
};

export const ElementWrapper = ({ value, ...rest }: TypographyWrapperProps) => {
  if (isValidElement(value)) return value;

  return <Typography {...rest}>{value}</Typography>;
};
